/*       */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormGroup from '@material-ui/core/FormGroup';
import MuiCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import { bind } from 'app/utils/decorators/decoratorUtils';
import { createEvent } from 'app/utils/http/event';

const CheckboxGroupWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: ${({ theme }) => theme.material.colors.background.fields};
    border-radius: 4px;
    padding: 8px 12px;
`;

const CheckboxGroupLabel = styled.label`
    font-size: 0.75rem;
    color: ${({ theme, error }) => error ? theme.material.colors.error.main : theme.material.colors.text.secondary};
    margin-bottom: 4px;

    .MuiFormLabel-asterisk {
        color: ${({ theme }) => theme.material.colors.error.main};
    }
`;

class CheckboxGroup extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        name: PropTypes.string,
        label: PropTypes.string,
        required: PropTypes.bool,
        error: PropTypes.bool,
        helperText: PropTypes.string,
        disabled: PropTypes.bool,
        value: PropTypes.array,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            })
        ),
    };

    static defaultProps = {
        color: 'primary',
        value: [],
    };

    @bind
    onChange(optionValue, checked) {
        const { value = [], name, onChange } = this.props;
        const newValue = checked
            ? [...value, optionValue]
            : value.filter(v => v !== optionValue);
        const event = createEvent('change', { name, value: newValue });
        onChange && onChange(event);
    }

    render() {
        const { color, value = [], options, disabled, label, required, error, helperText } = this.props;
        if (!options?.length) {
            return null;
        }
        return (
            <CheckboxGroupWrapper>
                {label && (
                    <CheckboxGroupLabel error={error}>
                        {label}{required && <span className="MuiFormLabel-asterisk"> *</span>}
                    </CheckboxGroupLabel>
                )}
                <FormGroup>
                    {options.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            label={option.label}
                            control={
                                <MuiCheckbox
                                    color={color}
                                    checked={Array.isArray(value) && value.includes(option.value)}
                                    onChange={(e) => this.onChange(option.value, e.target.checked)}
                                    disabled={disabled}
                                />
                            }
                            disabled={disabled}
                        />
                    ))}
                </FormGroup>
                {helperText && (
                    <FormHelperText error={error}>{helperText}</FormHelperText>
                )}
            </CheckboxGroupWrapper>
        );
    }
}

export default CheckboxGroup;
